import FormFieldWithInitialValue from 'libs/fields-manager/src/shared/stores/models/FieldModels/FormFieldWithInitialValue';

import SectionConfig from '../SectionConfig';

class ApplicationSectionsDetailModel {
  readonly multiStepSectionConfig: Array<SectionConfig>;
  initialSectionName: string;
  fieldsYupValidationConfig: any;

  formId: string;
  sectionsFormIds: Record<string, string> = {};
  productId: string;
  campusVisitProductId?: string;

  sectionsProductCodes: Record<string, any> = {};

  constructor(sectionDetailsConfig: any, fieldsYupValidationConfig: any) {
    this.multiStepSectionConfig = this.getSectionsConfig(sectionDetailsConfig);
    this.initialSectionName = sectionDetailsConfig[0].sectionNameEnum;
    this.fieldsYupValidationConfig = fieldsYupValidationConfig;
    sectionDetailsConfig.map((eachSection) => {
      if (eachSection?.productCode === 'CAMPUS_VISIT_SCHEDULER') {
        this.campusVisitProductId = eachSection.productCode;
      } else if (eachSection.sectionType === 'FORM') {
        if (!this.formId) {
          this.formId = eachSection.formId;
        }
        if (eachSection.formId) {
          this.sectionsFormIds[eachSection.sectionNameEnum] = eachSection.formId;
        }
      } else if (eachSection.sectionType === 'PRODUCT_REGISTRATION') {
        this.productId = eachSection.productCode;
      }
      if (eachSection.sectionType === 'PRODUCT_REGISTRATION') {
        this.sectionsProductCodes[eachSection.sectionNameEnum] =
          eachSection.productCode;
      } else if (
        eachSection.sectionType === 'TEMPLATE' &&
        eachSection.productCode
      ) {
        this.sectionsProductCodes[eachSection.sectionNameEnum] =
          eachSection.productCode;
      }
    });
  }

  getSectionsConfig(allSections: any[]) {
    return allSections.map((section: any) => {
      return new SectionConfig(section);
    });
  }

  get allSectionFields() {
    const allFields: Array<FormFieldWithInitialValue> = [];

    this.multiStepSectionConfig.forEach((section) => {
      allFields.push(...section.fields);
    });
    return allFields;
  }
}

export default ApplicationSectionsDetailModel;
